"use strict";
exports.__esModule = true;
exports.resetPrefillsAction = exports.setPrefillsIsLoadingAction = exports.setPrefillsHasAttemptedAction = exports.setPrefillsIsActiveAction = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.setPrefillsIsActiveAction = (0, toolkit_1.createAction)('prefills/set-is-active');
exports.setPrefillsHasAttemptedAction = (0, toolkit_1.createAction)('prefills/set-has-attempted');
exports.setPrefillsIsLoadingAction = (0, toolkit_1.createAction)('prefills/is-loading');
exports.resetPrefillsAction = (0, toolkit_1.createAction)('prefills/reset');
